import { render, staticRenderFns } from "./ListarDiagnosticos.vue?vue&type=template&id=029009f8&"
import script from "./ListarDiagnosticos.vue?vue&type=script&lang=js&"
export * from "./ListarDiagnosticos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports